import { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useSendTransaction } from '@privy-io/react-auth';

import { MovesEnum } from 'shared/constants/shared-enums';
import { generateSubSalt } from 'shared/constants/utils';
import { usePublicClient, useWalletClient, useAccount } from 'shared/hooks/use-web3';
import { usePlayerGamesStore } from 'shared/store/playerGamesStore';
import { useRoomStore } from 'shared/store/roomStore';

export const useMoveHandler = () => {
  const { activeRoomId } = useParams();

  const { address, chainId, isPrivyWallet } = useAccount();
  const publicClient = usePublicClient();
  const walletClient = useWalletClient();

  const { roundCounter, makeMoveAction } = useRoomStore();
  const { mainSalt, playMoves } = usePlayerGamesStore();

  const moveKey = useMemo(
    () => activeRoomId + address + chainId + roundCounter,
    [activeRoomId, address, chainId, roundCounter],
  );

  const { sendTransaction } = useSendTransaction();

  const handleSelectMove = useCallback(
    async (move: MovesEnum) => {
      if (playMoves?.[moveKey]?.move || !mainSalt[activeRoomId! + address + chainId]) return;
      let salt;
      try {
        console.log('generating salt');
        salt = await generateSubSalt(mainSalt[activeRoomId! + address + chainId], roundCounter);
      } catch (error) {
        console.log('error', error);
      }
      await makeMoveAction({
        roomId: BigInt(activeRoomId),
        roundCounter,
        salt,
        move,
        walletClient,
        publicClient,
        userAddress: address,
        isPrivyWallet,
        sendTransaction,
      });
    },
    [
      activeRoomId,
      address,
      chainId,
      roundCounter,
      playMoves,
      moveKey,
      mainSalt,
      makeMoveAction,
      walletClient,
      publicClient,
      sendTransaction,
      isPrivyWallet,
    ],
  );

  return { handleSelectMove };
};
